import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getApiUrl } from "./../utils/api";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    const bodyData = {
      username,
      password, // ✅ plain password
    };

    try {
      const res = await fetch(getApiUrl("admin-login"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyData),
      });

      const data = await res.json();

      if (data.message === "Login Successful") {
        localStorage.setItem("adminLoggedIn", "true");
        localStorage.setItem("adminId", data.adminId);
        localStorage.setItem("adminName", data.username);

        navigate("/bsk-secure-admin/dashboard");
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError("Server Error, try again!");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <h2>Admin Login</h2>

        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Enter username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit">Login</button>

          {error && <p className="error-msg">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
